import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHouseUserRegularIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 20 20",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M9.497 2.192a.746.746 0 0 1 1 0l7.25 6.5c.31.275.334.75.056 1.06a.75.75 0 0 1-1.06.056l-.25-.225v6.415a2 2 0 0 1-2 2h-9c-1.102 0-2-.896-2-2V9.583l-.25.225A.75.75 0 0 1 2.24 8.692zm.5 1.566-5 4.484v7.76c0 .275.225.5.5.5h9c.275 0 .5-.225.5-.5v-7.76l-5-4.481zm-1.75 5.244a1.751 1.751 0 0 1 3.5 0 1.751 1.751 0 0 1-3.5 0m-1.75 5.5a2.5 2.5 0 0 1 2.5-2.5h2a2.5 2.5 0 0 1 2.5 2.5c0 .275-.225.5-.5.5h-6a.5.5 0 0 1-.5-.5" })
});
export default SvgHouseUserRegularIcon;
